import { useState } from "react";
// import { Link } from "react-router-dom";
import { Bars3Icon } from "@heroicons/react/24/solid";
import { HashLink as Link } from "react-router-hash-link";
import Resume from "../../assets/resume/Toukir Ahammed - Front-End Developer - Resume.pdf";

const NavBar = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const closeNavbar = () => {
    setOpen(false);
  };

  return (
    <header className="bg-black bg-opacity-20">
      <nav className="flex flex-wrap gap-4 items-center w-full py-4 md:py-2 px-4 text-lg text-cyan-500 max-w-screen-xl mx-auto">
        <div className="flex-1">
          <Link to="/" className="hover:text-cyan-300">
            Toukir Ahammed
          </Link>
        </div>
        <div
          className={`${
            open ? null : "hidden"
          } w-full md:flex md:items-center md:justify-between md:w-auto order-3 md:order-2`}
          id="menu"
        >
          <ul
            className="
              text-base text-cyan-500
              pt-4
              md:flex
              md:justify-between
              md:pt-0"
          >
            <li>
              <Link
                onClick={closeNavbar}
                className="md:p-4 py-2 block hover:text-cyan-300"
                to="/#about-me"
              >
                About Me
              </Link>
            </li>
            <li>
              <Link
                onClick={closeNavbar}
                className="md:p-4 py-2 block hover:text-cyan-300"
                to="/#my-projects"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                onClick={closeNavbar}
                className="md:p-4 py-2 block hover:text-cyan-300"
                to="/#contact"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                onClick={closeNavbar}
                className="md:p-4 py-2 block hover:text-cyan-300"
                to="/blog"
              >
                Blog
              </Link>
            </li>
          </ul>
        </div>
        <Bars3Icon
          className="h-8 w-8 cursor-pointer md:hidden"
          onClick={handleClick}
        />
        <a
          href={Resume}
          target="_blank"
          rel="noreferrer"
          className="border border-cyan-500 rounded-md py-1 px-4 order-2 md:order-3"
        >
          Resume
        </a>
      </nav>
    </header>
  );
};

export default NavBar;
